/**
 * Store driving the Docker auto-discovery results dialog (Workstream B3).
 *
 * Every entry surface (New Connection dialog, command palette, Manage
 * Connections footer, start-page empty-state link) opens the dialog in its
 * `detecting` state, then drops the fresh detection result here. Detection is
 * stateless — nothing is cached between opens.
 */
import { create } from 'zustand';
import type { DockerDetectResult } from '../../../types/dockerDiscovery';

export type DockerDiscoverySource =
  | 'new_connection_dialog'
  | 'command_palette'
  | 'manage_dialog'
  | 'empty_state';

export type DockerDetectStatus = 'detecting' | 'done';

interface DockerDiscoveryState {
  isOpen: boolean;
  status: DockerDetectStatus;
  result: DockerDetectResult | null;
  source: DockerDiscoverySource;
  /** Open the dialog in its detecting (spinner) state for a fresh run. */
  openDetecting: (source: DockerDiscoverySource) => void;
  /** Drop the resolved detection result in. */
  setResult: (result: DockerDetectResult) => void;
  close: () => void;
}

export const useDockerDiscoveryStore = create<DockerDiscoveryState>((set) => ({
  isOpen: false,
  status: 'detecting',
  result: null,
  source: 'new_connection_dialog',
  openDetecting: (source) => set({ isOpen: true, status: 'detecting', result: null, source }),
  setResult: (result) => set({ status: 'done', result }),
  close: () => set({ isOpen: false }),
}));
